import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { addMedicalConditionType } from 'app/redux/store/features/medcond'
import { defaultMedicalConditionType } from './defaultMedicalConditionType'
import AddMedicalConditionTypeForm from './AddMedicalConditionTypeForm'

const AddMedicalConditionType = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar()
    const [medicalConditionTypeData] = useState({ ...defaultMedicalConditionType })
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const { loading, error } = useSelector((state) => state.medcond)

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)
        if (error) handleError(error)
        else {
            enqueueSnackbar('Medical condition type added successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            navigate('/settings/definitions/medical-condition-type')
        }
    }, [loading])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const onAdd = async () => {
        setApiCallInProgress(true)
        dispatch(addMedicalConditionType({ ...medicalConditionTypeData }))
    }

    return (
        <React.Fragment>
            <AddMedicalConditionTypeForm medicalConditionTypeData={medicalConditionTypeData} addMedicalConditionType={onAdd} />
        </React.Fragment>
    )
}

export default AddMedicalConditionType
